export function loadScriptByFile(src: string, callback: () => void) {
    const scriptElement: any = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.src = src;
    scriptElement.async = true;
    scriptElement.onload = scriptElement.onreadystatechange = function() {
        const rs = this.readyState;
        if (rs && rs !== 'complete' && rs !== 'loaded') {
            return;
        }

        try {
            callback();
        } catch (e) {
            console.error(e);
        }
    };
    const t = document.getElementsByTagName('script')[0];
    t.parentNode.insertBefore(scriptElement, t);
}
